<template>
    <div class="match-sign-up" v-loading="allLoading">
        <!-- 赛事基本信息卡片 -->
        <el-card class="info-card">
            <template #header>
                <div class="card-header">
                    <h3>赛事详情</h3>
                </div>
            </template>
            <div class="match-info">
                <div class="attachments">
                    <div class="label"> <i class="el-icon-document"></i>赛事名称：</div>
                    <div class="value" v-if="matchInfo">
                        {{ matchInfo.MatchName }}
                    </div>
                </div>

                <div class="attachments">
                    <div class="label"> <i class="el-icon-date"></i>报名时间：</div>
                    <div class="value" v-if="matchInfo">
                        {{ formatDateTime(matchInfo.SignUpStartTime) }}~{{ formatDateTime(matchInfo.SignUpEndTime) }}
                    </div>
                </div>

                <div class="attachments">
                    <div class="label"> <i class="el-icon-date"></i>比赛时间：</div>
                    <div class="value" v-if="matchInfo">
                        {{ formatDateTime(matchInfo.StartTime) }}~{{ formatDateTime(matchInfo.EndTime) }}
                    </div>
                </div>

                <div class="attachments">
                    <div class="label"> <i class="el-icon-location-outline"></i>赛事地点：</div>
                    <div class="value" v-if="matchInfo">
                        {{ matchInfo.MatchAddress }}
                    </div>
                </div>

                <!-- <div class="attachments">
                <div class="label"> <i class="el-icon-tickets"></i>赛事说明：</div>
                <div class="value" v-if="matchInfo">
                    {{ matchInfo.MatchIntroduction }}
                </div>
            </div> -->


                <div class="attachments">
                    <div class="label"> <i class="el-icon-document"></i>相关附件：</div>
                    <div class="value" v-if="matchInfo">
                        <span style="margin-right: 10px;text-decoration: underline;cursor: pointer;color: blue;"
                            v-for="(file, index) in matchInfo.Files" :key="index" @click="downloadFile(file)">
                            {{ file.FileName }}{{ file.FileSuffix }}
                        </span>
                    </div>
                </div>
            </div>

        </el-card>

        <!-- 分组卡片 -->
        <el-card class="info-card">
            <el-tabs type="border-card" @tab-click="tabClick" v-model="tabsValue">
                <el-tab-pane label="赛事项目" name="赛事项目">
                    <div v-if="matchInfo && matchInfo.MatchGroups && matchInfo.MatchGroups.length > 0">
                        <div style="position: absolute;right: 20px;">
                            <el-button
                                v-if="(!signUpGroupIds || signUpGroupIds.length == 0) && matchInfo.SignUpStatus != 1"
                                disabled size="small">报名结束</el-button>
                            <el-button v-if="matchInfo.SignUpStatus == 1" type="primary" size="small"
                                @click="handleClickSignUp">报名</el-button>
                            <el-button v-if="signUpGroupIds && signUpGroupIds.length > 0" size="small"
                                @click="toSignUpRecordPage">报名记录</el-button>
                        </div>
                        <div style="width: 85%;">
                            <el-radio-group v-model="groupRadioValue" @change="groupRadioChange" size="small">
                                <el-radio v-for="group in matchInfo.MatchGroups" :label="group.GroupId" border>
                                    <i style="font-size: 14px;"
                                        :class="group.IsSuper == 1 ? 'el-icon-chaoe' : 'el-icon-pu'"></i>
                                    {{ group.GroupName }}</el-radio>
                            </el-radio-group>
                            
                        </div>
                        <div class="match-project-list" style="margin-top: 10px;">
                            <el-table :data="matchProjects" style="width: 100%" border size="small">

                                <el-table-column prop="ProjectName" label="项目名称" width="350" align="center">
                                </el-table-column>
                                <el-table-column prop="ProjectTypeName" label="项目类型" width="150" align="center">
                                </el-table-column>
                                <el-table-column prop="GenderRuleText" label="项目性别" width="150" align="center">
                                </el-table-column>
                                <el-table-column label="报名类型" width="150" align="center">
                                    <template v-slot="scope">
                                        <span v-if="scope.row.SignUpLimitType == 0">团队</span>
                                        <span v-if="scope.row.SignUpLimitType == 1">个人</span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="参数人数限制" prop="SignUpLimitNumText" align="center">
                                </el-table-column>
                            </el-table>
                        </div>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="赛事说明" name="赛事说明">
                    <div v-if="matchInfo">{{ matchInfo.MatchIntroduction }}</div>
                </el-tab-pane>
                <el-tab-pane label="赛事成绩" name="赛事成绩">
                    <el-tabs type="border-card">
                        <el-tab-pane v-for="v in matchScores">
                            <span slot="label">{{ v.VenueName }}</span>
                            <el-collapse v-for="pro in v.Projects" v-if="v.Projects && v.Projects.length > 0">
                                <el-collapse-item :title="pro.GroupName + ' ' + pro.ProjectName" :name="pro.ProjectId">
                                    <el-table :data="pro.ContestantUser" size="mini" border>
                                        <el-table-column label="名称" prop="Ranking" align="center">
                                            <template v-slot="scope">
                                                {{ scope.row.Ranking > 0 ? scope.row.Ranking : '' }}
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="姓名" prop="UserName" align="center"></el-table-column>
                                        <el-table-column label="单位/学校" prop="Unit" align="center"></el-table-column>
                                        <el-table-column label="成绩" prop="Score" align="center">
                                            <template v-slot="scope">
                                                {{ scope.row.Score > 0 ? scope.row.Score : '' }}
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="得分" prop="TotalPoints" align="center">
                                            <template v-slot="scope">
                                                {{ scope.row.TotalPoints > 0 ? scope.row.TotalPoints : '' }}
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </el-collapse-item>
                            </el-collapse>
                            <div v-if="!v.Projects || v.Projects.length == 0">
                                暂未公布成绩
                            </div>
                        </el-tab-pane>
                    </el-tabs>
                </el-tab-pane>
            </el-tabs>


        </el-card>

        <!-- 选择运动员和随队人员的对话框 -->
        <el-dialog title="选择参赛人员" :visible.sync="dialogVisible" width="1200px" :close-on-click-modal="false"
            v-if="dialogVisible">
            <el-steps :active="sipnUpStep" finish-status="success" process-status="finish" size="mini" align-center>
                <el-step title="选择参赛项目"></el-step>
                <el-step title="随队人员登记"></el-step>
                <el-step title="上传集体照(上限5张)"></el-step>
                <el-step title="确认信息"></el-step>
            </el-steps>

            <div style="margin: 20px 20px;min-height: 400px;" v-show="sipnUpStep == 0">

                <el-tabs v-model="signUpTabsActiveName" type="card">
                    <el-tab-pane v-for="(group, index) in signUpMatchGroups" :label="group.GroupName"
                        :name="group.GroupId">
                        <div class="limit-info" style="margin-bottom: 15px; color: red;">
                            <p>限报年级：{{ group.GradeCondition ? group.GradeCondition : '不限' }}</p>
                            <p>限报年龄：
                                <span v-if="!group.BirthdayStartTime && !group.BirthdayEndTime">不限</span>
                                <span v-if="group.BirthdayStartTime && group.BirthdayEndTime">
                                    {{ group.BirthdayStartTime.split(' ')[0] }}至{{ group.BirthdayEndTime.split(' ')[0]
                                    }}出生
                                </span>
                                <span v-if="group.BirthdayStartTime && !group.BirthdayEndTime">
                                    {{ group.BirthdayStartTime.split(' ')[0] }}后出生
                                </span>
                                <span v-if="!group.BirthdayStartTime && group.BirthdayEndTime">
                                    {{ group.BirthdayEndTime.split(' ')[0] }}前出生
                                </span>
                                <span style="margin:0 10px;"
                                    v-if="group.MustHaveCertificate == 1">且运动员信息必须维护证件(团队管理-运动员管理中维护)</span>
                            </p>
                            <p>
                                队伍组成：领队{{ group.TeamLeaderMaxNum > 0 ?
                                    group.TeamLeaderMaxNum + '人' : '不限' }}，
                                教练{{ group.CoachMaxNum > 0 ?
                                    group.CoachMaxNum + '人' : '不限' }}，
                                医护人员{{ group.MedicalMaxNum > 0 ?
                                    group.MedicalMaxNum + '人' : '不限' }}，
                                合计运动员{{ group.AthleteMaxNum > 0 ?
                                    group.AthleteMaxNum + '人' : '不限' }}，
                                男运动员{{ group.BoyAthleteMaxNum > 0 ?
                                    group.BoyAthleteMaxNum + '人' : '不限' }}，
                                女运动员{{ group.GirlAthleteMaxNum > 0 ?
                                    group.GirlAthleteMaxNum + '人' : '不限' }}
                            </p>

                            <p>运动员限制：每人限报个人项目数{{
                                group.EveryBodyRestrictReportPersonalProjectMaxNum > 0
                                    ?
                                    group.EveryBodyRestrictReportPersonalProjectMaxNum
                                    + '个'
                                    : '不限' }}，
                                每人限报团队项目数{{
                                    group.EveryBodyRestrictReportTeamProjectMaxNum > 0
                                        ?
                                        group.EveryBodyRestrictReportTeamProjectMaxNum
                                        + '个' :
                                        '不限' }}</p>
                        </div>
                        <div class="match-project-list" style="margin-top: 10px;">
                            <el-table :data="group.Projects" style="width: 100%" border size="small"
                                @selection-change="(val) => handleProSelectionChange(val, index)">
                                <el-table-column type="selection" width="55" align="center"></el-table-column>
                                <el-table-column prop="ProjectName" label="项目名称" width="180" align="center">
                                    <template v-slot="scope">
                                        <el-tag size="mini" type="danger" v-if="scope.row.IsMustSignUp == 1">必报</el-tag>
                                        {{ scope.row.ProjectName }}
                                    </template>
                                </el-table-column>
                                <el-table-column prop="ProjectTypeName" label="项目类型" width="120" align="center">
                                </el-table-column>
                                <el-table-column prop="GenderRuleText" label="性别" width="120" align="center">
                                </el-table-column>
                                <el-table-column label="报名类型" width="80" align="center">
                                    <template v-slot="scope">
                                        <span v-if="scope.row.SignUpLimitType == 0">团队</span>
                                        <span v-if="scope.row.SignUpLimitType == 1">个人</span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="SignUpLimitNumText" label="项目人数" width="120"
                                    align="center"></el-table-column>
                                <el-table-column label="参赛运动员">
                                    <template v-slot="scope">
                                        <div style="position: relative;width: 100%;overflow: auto;">
                                            <span v-if="scope.row.athletes && scope.row.athletes.length > 0">
                                                <el-tag v-for="(item, i) in scope.row.athletes" :key="i" closable
                                                    @close="removeAthlete(index, scope.$index, i)" style="margin: 2px">
                                                    {{ item.userNames }}
                                                </el-tag>
                                            </span>
                                            <el-button size="mini" icon="el-icon-plus" circle
                                                v-if="signUpMatchGroups[index].checkedPros.find(a => a.ProjectId == scope.row.ProjectId) &&
                                                    (!scope.row.athletes || scope.row.athletes.length < scope.row.SignUpLimitNum)"
                                                @click="openAthleteDialog(scope.row, index)">
                                            </el-button>
                                        </div>

                                    </template>
                                </el-table-column>
                                <!-- <el-table-column label="上传音乐" width="100" align="center">
                                    <template v-slot="scope">
                                        <el-upload class="upload-demo" action="#"
                                            :http-request="(file) => uploadFile(file, index + '-' + scope.$index)"
                                            :multiple="false" :show-file-list="false" accept=".mp3"
                                            v-if="(scope.row.ProjectTypeId == '54D80337-77B2-4C38-BC3A-7880113D5F8D' ||
                                                scope.row.ProjectTypeId == 'B5D7A393-8CF1-45C0-8776-CD9D7DC2C01C')
                                                && signUpMatchGroups[index].checkedPros.find(a => a.ProjectId == scope.row.ProjectId)">
                                            <el-button v-if="!scope.row.File || scope.row.File.FileId == ''" size="mini"
                                                type="primary">上传音乐</el-button>

                                            <el-tooltip v-if="scope.row.File && scope.row.File.FileId != ''"
                                                :content="scope.row.File.FileName + scope.row.File.FileSuffix"
                                                effect="light">
                                                <el-button size="mini" type="success">已上传</el-button>
                                            </el-tooltip>
                                        </el-upload>

                                        <span
                                            v-if="(scope.row.ProjectTypeId == 'F679B7E4-F852-4A2A-BAF2-EC21BE923826' ||
                                                scope.row.ProjectTypeId == 'A8CF0C94-4A2B-495C-8E4C-861357928917')
                                                && signUpMatchGroups[index].checkedPros.find(a => a.ProjectId == scope.row.ProjectId)">无需上传</span>
                                    </template>
                                </el-table-column> -->
                            </el-table>
                        </div>
                    </el-tab-pane>

                </el-tabs>
            </div>
            <div style=" margin: 20px 20px;min-height: 400px;" v-show="sipnUpStep == 1">
                <el-table :data="unitStaffList" style="width: 100%" border size="small" max-height="300px"
                    @selection-change="handleStaffTableSelectionChange">
                    <el-table-column type="selection" width="55" align="center">
                    </el-table-column>
                    <el-table-column prop="StaffName" label="姓名" width="150" align="center"></el-table-column>
                    <el-table-column prop="Gender" label="性别" width="100" align="center">
                        <template #default="scope">
                            <span v-if="scope.row.Gender == 0">男子</span>
                            <span v-else>女子</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="Age" label="年龄" width="100" align="center"></el-table-column>
                    <!-- <el-table-column prop="IdCardType" label="证件类型" width="120"></el-table-column> -->
                    <el-table-column prop="IdentityCard" label="身份证号码" width="150" align="center"></el-table-column>
                    <el-table-column prop="Birthday" label="出生日期" width="120" align="center">
                        <template v-slot="scope">
                            {{ formatBirthday(scope.row.Birthday) }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="StaffPhone" label="手机号码" width="150" align="center"></el-table-column>
                    <el-table-column prop="Post" label="身份" width="120" align="center"></el-table-column>
                    <el-table-column prop="Remarks" label="备注" align="center"></el-table-column>
                </el-table>
            </div>
            <div style="margin: 20px 20px; text-align: center;min-height: 400px;" v-show="sipnUpStep == 2">
                <div class="teamPhoto" style="padding-top: 50px;box-sizing: border-box;">
                    <el-upload action="#" list-type="picture-card" :on-preview="handlePictureCardPreview"
                        :http-request="(file) => uploadFile(file, 'teamPhoto')" :file-list="fileList"
                        :on-remove="handleRemove" :on-exceed="handleExceed" accept=".jpg,.png,.jpeg" :limit="5"
                        multiple>
                        <i class="el-icon-plus"></i>
                    </el-upload>

                </div>
            </div>
            <div style="margin: 20px 20px; text-align: center;min-height: 400px;" v-show="sipnUpStep == 3">
                <!-- 报名表确认视图 -->
                <div class="sign-up-confirmation">
                    <!-- 基本信息部分 -->
                    <div class="basic-info">
                        <table class="info-table">
                            <tr>
                                <td class="label">赛事名称：</td>
                                <td colspan="3">{{ matchInfo.MatchName }}</td>
                            </tr>
                            <tr>
                                <td class="label">赛事时间：</td>
                                <td colspan="3">{{ formatDateTime(matchInfo.StartTime) }} ~ {{
                                    formatDateTime(matchInfo.EndTime) }}</td>
                            </tr>
                            <tr>
                                <td class="label">参赛单位：</td>
                                <td colspan="3">{{ unitInfo.UnitName }}</td>
                            </tr>
                            <tr>
                                <td class="label">单位联系人：</td>
                                <td>{{ unitInfo.UnitManagerName }}</td>
                                <td class="label">联系电话：</td>
                                <td>{{ unitInfo.UnitManagerPhone }}</td>
                            </tr>
                        </table>
                    </div>

                    <!-- 参赛项目列表 -->
                    <div class="projects-list">
                        <h4>参赛项目</h4>
                        <el-table :data="getFlattenedProjectsList()" border size="small"
                            :span-method="handleProjectSpanMethod">
                            <el-table-column prop="groupName" label="组别" align="center"></el-table-column>
                            <el-table-column prop="projectName" label="项目名称" align="center"></el-table-column>
                            <el-table-column prop="projectTypeName" label="项目类型" align="center"></el-table-column>
                            <el-table-column prop="genderRuleText" label="性别" align="center"></el-table-column>
                            <el-table-column prop="athleteName" label="参赛运动员" align="center"></el-table-column>
                        </el-table>
                    </div>

                    <!-- 参赛运动员详细信息列表 -->
                    <div class="athletes-detail-list" v-if="getAllAthletes().length > 0">
                        <h4>参赛运动员信息</h4>
                        <el-table :data="getAllAthletes()" border size="small">
                            <el-table-column prop="athleteName" label="姓名" align="center"></el-table-column>
                            <el-table-column prop="identityCard" label="身份证" align="center"></el-table-column>
                            <el-table-column prop="age" label="年龄" align="center"></el-table-column>
                            <el-table-column prop="gender" label="性别" align="center">
                                <template #default="scope">
                                    <span>{{ scope.row.gender === 0 ? '男子' : '女子' }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="phone" label="联系电话" align="center"></el-table-column>
                            <el-table-column prop="grade" label="年级" align="center"></el-table-column>
                        </el-table>
                    </div>

                    <!-- 随队人员列表 -->
                    <div class="staff-list" v-if="staffTableSelection.length > 0">
                        <h4>随队人员</h4>
                        <el-table :data="staffTableSelection" border size="small">
                            <el-table-column prop="StaffName" label="姓名" align="center"></el-table-column>
                            <el-table-column prop="IdentityCard" label="身份证" align="center"></el-table-column>
                            <el-table-column prop="Age" label="年龄" align="center"></el-table-column>
                            <el-table-column prop="Gender" label="性别" align="center">
                                <template #default="scope">
                                    <span>{{ scope.row.Gender === 0 ? '男子' : '女子' }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="StaffPhone" label="联系电话" align="center"></el-table-column>
                            <el-table-column prop="Post" label="身份" align="center"></el-table-column>
                        </el-table>
                    </div>
                </div>
            </div>

            <template #footer>
                <el-button @click="dialogVisible = false" type="info" size="small">取消</el-button>
                <el-button type="primary" @click="backStep" size="small" v-if="sipnUpStep > 0">上一步</el-button>
                <el-button type="primary" @click="handleNextStep" size="small" v-if="sipnUpStep < 3">下一步</el-button>
                <el-button  @click="confirmSignUp('存草稿')" size="small">存草稿</el-button>
                <el-button type="primary" @click="confirmSignUp('提交')" size="small" v-if="sipnUpStep == 3">提交报名</el-button>
            </template>
        </el-dialog>
        <el-dialog :visible.sync="imageDialogVisible">
            <img width="100%" :src="dialogImageUrl" alt="">
        </el-dialog>
        <!-- 在 template 中添加运动员选择对话框 -->
        <el-dialog title="选择运动员" :visible.sync="athleteDialogVisible" width="800px" :close-on-click-modal="false">
            <div v-if="currentProject">
                <div class="limit-info" style="margin-bottom: 15px; color: #E6A23C;">
                    <el-alert :title="currentProject.SignUpLimitType === 0 ?
                        `该项目最多可选择 ${currentProject.SignUpLimitNum} 个团队` :
                        `该项目最多可选择 ${currentProject.SignUpLimitNum} 名运动员`" type="warning" :closable="false" show-icon>
                    </el-alert>
                </div>

                <div v-if="currentProject.SignUpLimitType === 0" class="team-select">
                    <!-- 已选择的团队列表 -->
                    <div class="selected-teams" v-if="selectedTeams.length > 0">
                        <h4>已选择的团队 ({{ selectedTeams.length }}/{{ currentProject.SignUpLimitNum }})：</h4>
                        <div class="team-list">
                            <!-- <el-tag v-for="(team, index) in selectedTeams" :key="index" closable
                                @close="removeTeam(index)" style="margin: 5px">
                                {{ team.userNames }}
                            </el-tag> -->
                            <el-table :data="selectedTeams" style="width: 100%" size="mini" border>
                                <el-table-column label="运动员" prop="userNames">
                                </el-table-column>
                                <el-table-column label="操作" width="100" align="center">
                                    <template slot-scope="scope">
                                        <el-button type="text" style="color: red;" size="mini"
                                            @click="removeTeam(scope.$index)">
                                            删除
                                        </el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </div>

                    <!-- 选择运动员组建团队 -->
                    <div class="create-team">
                        <h4>组建新团队</h4>
                        <el-select size="small" v-model="tempSelectedAthletes" multiple placeholder="请选择运动员组建团队"
                            style="margin-bottom: 10px;width: 80%;">
                            <el-option
                                v-for="athlete in unitAthleteList.filter(a => (signUpMatchGroups[0].GradeCondition == '' || signUpMatchGroups[0].GradeConditionArr.indexOf(a.Grade) > -1) && (currentProject.GenderRule == 2 || currentProject.GenderRule == a.Gender))"
                                :key="athlete.AthleteId"
                                :label="athlete.UserName + '(' + (athlete.Gender == 0 ? '男' : '女') + ')'"
                                :value="athlete.AthleteId">
                                <span style="float: left">{{ athlete.UserName }}
                                    <el-tag :type="athlete.Gender == 0 ? '' : 'danger'" style="margin: 0 5px;"
                                        size="mini">{{
                                            (athlete.Gender == 0 ? '男' : '女')
                                        }}</el-tag>
                                    <el-tag style="margin: 0 5px;" size="mini">{{ athlete.Grade }}</el-tag>
                                </span>
                                <span style="float: right; color: #8492a6; font-size: 13px">{{ athlete.GroupId }}</span>
                            </el-option>
                        </el-select>
                        <el-button size="small" type="primary" @click="createTeam"
                            :disabled="!tempSelectedAthletes.length">
                            确认组建团队
                        </el-button>
                    </div>

                    <el-divider>或</el-divider>

                    <!-- 选择已有团队 -->
                    <div class="select-team">
                        <h4>选择已有团队</h4>
                        <el-table :data="unitTeamList" style="width: 100%" border size="mini" class="compact-table">
                            <el-table-column prop="TeamName" label="团队名称"></el-table-column>
                            <el-table-column prop="AthleteNames" label="团队成员"></el-table-column>
                            <el-table-column prop="Remarks" label="团队备注"></el-table-column>
                            <el-table-column label="操作" width="100" align="center">
                                <template v-slot="scope">
                                    <el-button type="text" size="mini" @click="addExistingTeam(scope.row)">
                                        添加
                                    </el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
                <div v-else>
                    <!-- 个人模式 -->
                    <h4>已选择运动员 ({{ selectedAthleteIds.length }}/{{ currentProject.SignUpLimitNum }})：</h4>
                    <el-select v-model="selectedAthleteIds" multiple placeholder="请选择运动员" style="width: 100%">
                        <el-option
                            v-for="athlete in unitAthleteList.filter(a => (signUpMatchGroups[0].GradeCondition == '' || signUpMatchGroups[0].GradeConditionArr.indexOf(a.Grade) > -1) && (currentProject.GenderRule == 2 || currentProject.GenderRule == a.Gender))"
                            :key="athlete.AthleteId"
                            :label="athlete.UserName + '(' + (athlete.Gender == 0 ? '男' : '女') + ') '"
                            :value="athlete.AthleteId">
                            <span style="float: left">{{ athlete.UserName }}
                                <el-tag :type="athlete.Gender == 0 ? '' : 'danger'" style="margin: 0 5px;"
                                    size="mini">{{
                                        (athlete.Gender == 0 ? '男' : '女')
                                    }}</el-tag>
                                <el-tag style="margin: 0 5px;" size="mini">{{ athlete.Grade }}</el-tag>
                                <el-tag style="margin: 0 5px;" size="mini">{{ athlete.Age }}岁</el-tag>
                                <el-tag style="margin: 0 5px;" size="mini">{{ athlete.Birthday.split(' ')[0] }}</el-tag>
                            </span>
                            <span style="float: right; color: #8492a6; font-size: 13px">{{ athlete.GroupId }}</span>
                        </el-option>
                    </el-select>
                </div>
            </div>
            <template #footer>
                <el-button type="primary" v-if="selectedAthleteIds.length > 0 || selectedTeams.length > 0"
                    @click="confirmAthleteSelection" size="small">确定</el-button>
                <el-button @click="athleteDialogVisible = false" type="info" size="small">取消</el-button>
            </template>
        </el-dialog>
        <el-dialog title="报名信息" :visible.sync="signUpResultDialogVisible" top="30px" width="900px"
            :close-on-click-modal="false">
            <MatchSignResult :signData="signUpRecord" ref="signResultComponent" />
            <template #footer>
                <!-- <el-button type="primary" @click="printSignUpForm" size="small">打印</el-button> -->
                <el-button @click="hideSignUpFormDialog" size="small">关闭</el-button>
            </template>
        </el-dialog>
    </div>
</template>

<script>
import systemService from '@/request-server/request-services/system-services.js';
import contestantServices from "@/request-server/request-services/contestant-services.js";
import Url from '@/request-server/request-url';
import utilsCommon from '@/utils/utils-common';
import { mapState } from 'vuex';
import MatchSignResult from '@/components/common/match-sign-result.vue';
import matchService from "@/request-server/request-services/match-services.js";

export default {
    name: 'MatchSignUp',
    components: { MatchSignResult },
    data() {
        return {
            imageDialogVisible: false,
            dialogImageUrl: '',
            fileList: [],
            fileRootPath: '',
            allLoading: false,
            matchInfo: null,
            selectedProjects: [],
            dialogVisible: false,
            athletesList: [],
            staffList: [],
            selectedAthletes: [],
            selectedStaff: [],
            groupRadioValue: '',
            matchProjects: [],
            sipnUpStep: 0,
            signUpTabsActiveName: '',
            signUpMatchGroups: [],
            unitStaffList: [],
            unitAthleteList: [],
            staffTableSelection: [],
            teamPhotoFiles: [],
            athleteDialogVisible: false,
            currentProject: null,
            athleteActiveTab: 'athletes',
            selectedTeams: [],
            selectedAthleteIds: [],
            unitTeamList: [],
            currentGroupIndex: null,
            currentProjectIndex: null,
            tempSelectedAthletes: [], // 临时存储正在组建的团队成员
            signUpRecord: null,
            signUpResultDialogVisible: false,
            tabsValue: '赛事项目',
            matchScores: null,
            signUpGroupIds: [],
        }
    },
    computed: {
        ...mapState({
            unitInfo: state => state.unitInfo
        })
    },
    methods: {
        printSignUpForm() {
            this.$refs.signResultComponent.printForm();
        },
        hideSignUpFormDialog() {
            this.signUpResultDialogVisible = false;
        },
        handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.imageDialogVisible = true;
        },
        handleRemove(file) {
            // 从 fileList 中找到要删除的文件的索引
            const fileIndex = this.fileList.findIndex(item => item.url === file.url);
            if (fileIndex > -1) {
                // 从 fileList 中移除该文件
                this.fileList.splice(fileIndex, 1);
                this.teamPhotoFiles.splice(fileIndex, 1);
            }
        },

        // 获取赛事信息
        getMatchDetail() {
            let id = this.$route.params.id;
            if (id) {
                this.allLoading = true;
                contestantServices.getMatchDetail({ matchId: id }).then(resData => {
                    this.allLoading = false;
                    if (resData.code == 0) {
                        this.matchInfo = resData.data;
                        if (this.matchInfo && this.matchInfo.MatchGroups && this.matchInfo.MatchGroups.length > 0) {
                            this.groupRadioValue = this.matchInfo.MatchGroups[0].GroupId;
                            this.matchProjects = this.matchInfo.MatchGroups[0].Projects;
                            if (this.matchProjects && this.matchProjects.length > 1) {
                                this.matchProjects = this.matchProjects.sort((a, b) => a.GenderRule - b.GenderRule)
                            }
                        }
                    }
                }).finally(() => {
                    this.allLoading = false;
                })

            } else {
                this.$router.replace('/contestant');
            }
        },
        checkUnitIsSignUp() {
            let id = this.$route.params.id;
            if (id) {
                this.allLoading = true;
                contestantServices.checkUnitIsSignUp({ matchId: id }).then(resData => {
                    this.allLoading = false;
                    if (resData.code == 0) {
                        this.signUpGroupIds = resData.data;
                    }
                }).finally(() => {
                    this.allLoading = false;
                })

            }
        },
        getUnitTeamLeaders() {
            let data = {
                PageIndex: 1,
                PageSize: 9999,
                Where: {}
            }
            this.unitStaffList = [];
            contestantServices.selectUnitTeamLeaders(data).then(res => {
                if (res.code == 0) {
                    this.unitStaffList = res.data.Data;

                }
            })
        },
        getUnitAthletes() {
            let data = {
                PageIndex: 1,
                PageSize: 9999,
                Where: {}
            }
            this.unitAthleteList = [];
            contestantServices.selectUnitAthletes(data).then(res => {
                if (res.code == 0 && res.data.Data) {
                    this.unitAthleteList = res.data.Data;
                }
            })
        },
        getUnitTeams() {
            let data = {
                PageIndex: 1,
                PageSize: 9999,
                Where: {
                }
            }
            this.unitTeamList = [];
            contestantServices.selectUnitTeams(data).then(resDate => {
                if (resDate.code == 0) {
                    this.unitTeamList = resDate.data.Data;
                }
            })
        },
        groupRadioChange() {
            this.matchProjects = [];
            let group = this.matchInfo.MatchGroups.find(a => a.GroupId == this.groupRadioValue);
            if (group) {
                this.matchProjects = group.Projects;
                if (this.matchProjects && this.matchProjects.length > 1) {
                    this.matchProjects = this.matchProjects.sort((a, b) => a.GenderRule - b.GenderRule)
                }
            }
        },
        dialogGroupRadioChange() {
            this.dialogMatchProjects = [];
            let group = this.matchInfo.MatchGroups.find(a => a.GroupId == this.dialogGroupRadioValue);
            if (group) {
                this.dialogMatchProjects = [...group.Projects];
            }
        },
        // 处理报名按钮点击
        handleClickSignUp() {
            if (!this.unitInfo.UnitId) {
                this.$confirm('请先完善个人信息?', '提示', {
                    confirmButtonText: '去完善信息',
                    type: 'warning',
                    showClose: false,
                    showCancelButton: false
                }).then(() => {
                    this.$router.replace({ path: '/contestant/personal-center' });
                }).catch(() => {
                    this.$router.replace({ path: '/contestant/personal-center' });
                })
            }

            if (!this.groupRadioValue) {
                this.$message.warning('请选择一个组别');
                return;
            }

            let group = this.matchInfo.MatchGroups.find(a => a.GroupId == this.groupRadioValue);
            console.log(group, this.unitInfo);
            if ((group.IsSuper == 1 && this.unitInfo.IsSuper != 1)
                || (group.IsSuper == 0 && this.unitInfo.IsSuper == 1)) {
                this.$message.warning(this.unitInfo.IsSuper == 1 ? '您只能参加超级组项目' : '您只能参加普通组项目');
                return;
            }
            this.staffTableSelection = [];
            if (this.signUpGroupIds && this.signUpGroupIds.indexOf(this.groupRadioValue) > -1) {
                this.$confirm('您已报名该组项目，重复报名将会覆盖掉已报名的数据，是否继续？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消'
                }).then(() => {
                    this.sipnUpStep = 0;
                    // 修改这里，只添加当前选中的分组到signUpMatchGroups
                    const selectedGroup = this.matchInfo.MatchGroups.find(g => g.GroupId === this.groupRadioValue);
                    if (selectedGroup) {
                        this.signUpMatchGroups = utilsCommon.copyObj([{ ...selectedGroup, checkedPros: [] }]);
                        this.signUpTabsActiveName = selectedGroup.GroupId;
                    }
                    this.dialogVisible = true;
                })
            } else {

                if (group.MustHaveCertificate == 1) {
                    this.$confirm('参与该组项目运动员必须是已维护证件信息，是否继续报名？', '提示', {
                        confirmButtonText: '我已知晓，继续报名',
                        cancelButtonText: '取消'
                    }).then(() => {
                        this.sipnUpStep = 0;
                        // 修改这里，只添加当前选中的分组到signUpMatchGroups
                        const selectedGroup = this.matchInfo.MatchGroups.find(g => g.GroupId === this.groupRadioValue);
                        if (selectedGroup) {
                            this.signUpMatchGroups = utilsCommon.copyObj([{ ...selectedGroup, checkedPros: [] }]);
                            this.signUpTabsActiveName = selectedGroup.GroupId;
                        }
                        this.dialogVisible = true;
                    })
                } else {
                    this.sipnUpStep = 0;
                    // 修改这里，只添加当前选中的分组到signUpMatchGroups
                    const selectedGroup = this.matchInfo.MatchGroups.find(g => g.GroupId === this.groupRadioValue);
                    if (selectedGroup) {
                        this.signUpMatchGroups = utilsCommon.copyObj([{ ...selectedGroup, checkedPros: [] }]);
                        this.signUpTabsActiveName = selectedGroup.GroupId;
                    }
                    this.dialogVisible = true;
                }
            }
        },
        handleProSelectionChange(val, index) {
            // 获取当前组的项目列表
            const currentProjects = this.signUpMatchGroups[index].Projects;
            // 获取之前选中的项目ID列表
            const previousCheckedIds = (this.signUpMatchGroups[index].checkedPros || []).map(p => p.ProjectId);
            // 获取新选中的项目ID列表
            const newCheckedIds = val.map(p => p.ProjectId);

            // 更新选中的项目
            this.signUpMatchGroups[index].checkedPros = val;

            // 找出被取消选中的项目ID
            const uncheckedIds = previousCheckedIds.filter(id => !newCheckedIds.includes(id));

            // 清除被取消项目的运动员
            uncheckedIds.forEach(projectId => {
                const projectIndex = currentProjects.findIndex(p => p.ProjectId === projectId);
                if (projectIndex !== -1) {
                    this.$set(currentProjects[projectIndex], 'athletes', []);
                }
            });
        },

        handleStaffTableSelectionChange(val) {
            this.staffTableSelection = val;
        },

        backStep() {
            this.sipnUpStep -= 1;
        },
        handleNextStep() {
            // 步骤0：验证是否选择了项目和运动员
            if (this.sipnUpStep === 0) {
                // 检查是否有选中的项目
                let hasSelectedProjects = false;
                // 检查是否为选中的项目选择了运动员
                let hasSelectedAthletes = false;
                // 检查必报项目是否都已选择
                let missingMustSignUpProjects = [];

                for (const group of this.signUpMatchGroups) {
                    // 检查必报项目
                    group.Projects.forEach(project => {
                        if (project.IsMustSignUp === 1) {
                            const isSelected = group.checkedPros.some(p => p.ProjectId === project.ProjectId);
                            if (!isSelected) {
                                missingMustSignUpProjects.push(`${group.GroupName}-${project.ProjectName}`);
                            }
                        }
                    });

                    if (group.checkedPros && group.checkedPros.length > 0) {
                        hasSelectedProjects = true;

                        // 检查是否为每个选中的项目选择了运动员
                        for (const project of group.Projects) {
                            // 只检查被选中的项目
                            if (group.checkedPros.find(p => p.ProjectId === project.ProjectId)) {
                                if (project.athletes && project.athletes.length > 0) {
                                    hasSelectedAthletes = true;
                                    break;
                                }
                            }
                        }
                    }
                }

                // 检查是否有未选择的必报项目
                if (missingMustSignUpProjects.length > 0) {
                    this.$message.warning(`以下必报项目尚未选择：${missingMustSignUpProjects.join('、')}`);
                    return;
                }

                if (!hasSelectedProjects) {
                    this.$message.warning('请至少选择一个参赛项目');
                    return;
                }

                if (!hasSelectedAthletes) {
                    this.$message.warning('请为选中的项目添加参赛运动员');
                    return;
                }
            }

            // 步骤1：验证是否选择了随队人员
            else if (this.sipnUpStep === 1) {
                if (this.staffTableSelection.length === 0) {
                    this.$message.warning('请至少选择一名随队人员');
                    return;
                }
            }

            // 通过验证，进入下一步
            this.sipnUpStep += 1;
        },

        handleExceed(files, fileList) {
            this.$message.warning(`最多只能上传 5 张图片`);
        },

        uploadFile(options, fileType) {
            const file = options.file;
            const formData = new FormData();
            formData.append('files', file);
            formData.append('desc', 'sign-up-files');
            formData.append('type', 'sign-up-files');

            systemService.uploadFiles(formData).then(res => {
                if (res.code == 0) {
                    if (fileType == 'teamPhoto') {
                        res.data.forEach(fileItem => {
                            let uploadFile = fileItem;
                            uploadFile['TeamPhotoFilePath'] = uploadFile.SaveFolder + '/' + uploadFile.FileId + uploadFile.FileSuffix;
                            this.teamPhotoFiles.push(uploadFile);
                            this.fileList.push({
                                name: uploadFile.FileName,
                                url: this.fileRootPath + uploadFile.TeamPhotoFilePath
                            });
                        });
                    } else {
                        //音乐文件
                        //解析groupindex-projectindex
                        let idxs = fileType.split('-');
                        //this.signUpMatchGroups[idxs[0]].Projects[idxs[1]]['File'] = res.data[0];
                        this.$set(this.signUpMatchGroups[idxs[0]].Projects[idxs[1]], 'File', res.data[0]);
                    }

                    this.$message.success('上传成功');
                }
            });
        },
        beforePhotoUpload(file) {
            const isJPGOrPNG = file.type === 'image/jpeg' || file.type === 'image/png';
            const isLt2M = file.size / 1024 / 1024 < 2;

            if (!isJPGOrPNG) {
                this.$message.error('照片只能是JPG或PNG格式!');
                return false;
            }
            if (!isLt2M) {
                this.$message.error('照片大小不能超过2MB!');
                return false;
            }
            return true;
        },

        handleDeleteImage(fileType) {
            // 实现图片删除逻辑
            if (fileType === 'teamPhoto') {
                this.teamPhotoFile = null;
            }
        },
        // 确认报名
        confirmSignUp(type = '提交') {
            // 构建报名数据对象
            const signUpData = {
                MatchId: this.matchInfo.MatchId,                    // 赛事ID
                UnitId: this.unitInfo.UnitId,                      // 单位ID
                GroupId: this.groupRadioValue, 
                SubmitType: type,                    // 分组ID
                SignUpGroups: this.buildSignUpGroupsData(),        // 报名分组和项目数据
                TeamLeaderIds: this.buildTeamLeadersData(),          // 随队人员数据
                TeamPhotoFileIds: this.teamPhotoFiles == null ? [] : this.buildTeamPhotoFilesData()    // 团队照片数据
            };

            contestantServices.submitMatchSignUpForm(signUpData).then(res => {
                if (res.code === 0) {
                    if (type === '提交') {
                        this.$message.success('报名成功');
                    } else {
                        this.$message.success('存草稿成功');
                    }
                    this.dialogVisible = false;
                    this.checkUnitIsSignUp();
                }
            });
        },
        // 构建报名分组和项目数据
        buildSignUpGroupsData() {
            const signUpGroups = [];

            this.signUpMatchGroups.forEach(group => {
                // 只处理有选中项目的分组
                if (group.checkedPros && group.checkedPros.length > 0) {
                    const groupData = {
                        GroupId: group.GroupId,
                        Projects: []
                    };

                    // 处理该分组下的所有选中项目
                    group.Projects.forEach(project => {
                        // 只处理有运动员的项目
                        if (project.athletes && project.athletes.length > 0) {
                            const projectData = {
                                ProjectId: project.ProjectId,
                                SignUpType: project.SignUpLimitType, // 0:团队 1:个人
                                Athletes: [],
                                MusicFile: project.File || null      // 如果有音乐文件
                            };

                            // 简化处理项目的运动员数据
                            if (project.SignUpLimitType === 0) {
                                // 团队模式 - 把每个团队的运动员ID拼接成字符串
                                projectData.Athletes = project.athletes.map(team => {
                                    // 确保userIds是字符串
                                    return Array.isArray(team.userIds) ?
                                        team.userIds.join(',') :
                                        team.userIds;
                                });
                            } else {
                                // 个人模式 - 提供每个运动员ID
                                projectData.Athletes = project.athletes.map(athlete =>
                                    athlete.userIds
                                );
                            }

                            groupData.Projects.push(projectData);
                        }
                    });

                    signUpGroups.push(groupData);
                }
            });

            return signUpGroups;
        },

        // 构建随队人员数据
        buildTeamLeadersData() {
            return this.staffTableSelection.map(staff => staff.TeamLeaderId);
        },

        // 构建团队照片数据
        buildTeamPhotoFilesData() {
            // return this.teamPhotoFiles.map(file => ({
            //     FileId: file.FileId,
            //     FileName: file.FileName,
            //     FilePath: file.TeamPhotoFilePath
            // }));
            return this.teamPhotoFiles.map(file => file.FileId);
        },

        // 格式化日期时间，移除ISO格式中的T
        formatDateTime(dateTimeStr) {
            if (!dateTimeStr) return '';
            // 替换字符串中的'T'为空格
            return dateTimeStr.replace('T', ' ');
        },
        formatBirthday(dateTimeStr) {
            if (!dateTimeStr) return '';
            // 替换字符串中的'T'为空格
            return dateTimeStr.split('T')[0];
        },
        openAthleteDialog(project, index) {
            this.currentProject = project;
            this.currentGroupIndex = index;
            this.currentProjectIndex = this.signUpMatchGroups[index].Projects.indexOf(project);
            this.athleteActiveTab = 'athletes';
            this.tempSelectedAthletes = []; // 清空临时选择的运动员

            // 如果已有选择的运动员，初始化数据
            if (project.athletes && project.athletes.length > 0) {
                if (project.SignUpLimitType === 0) {
                    // 团队模式
                    this.selectedTeams = project.athletes.map(team => ({
                        userIds: typeof team.userIds === 'string' ? team.userIds.split(',') : team.userIds,
                        userNames: team.userNames
                    }));
                } else {
                    // 个人模式
                    this.selectedAthleteIds = project.athletes.map(athlete =>
                        typeof athlete.userIds === 'string' ? athlete.userIds : athlete.userIds.toString()
                    );
                }
            } else {
                // 没有已选运动员时的初始化
                if (project.SignUpLimitType === 0) {
                    this.selectedTeams = [];  // 改为空数组，不预设团队
                } else {
                    this.selectedAthleteIds = [];
                }
            }

            this.athleteDialogVisible = true;
        },
        handleTeamAthleteChange(event, teamIndex) {
            this.selectedTeams[teamIndex].userIds = event;
        },
        addNewTeam() {
            this.selectedTeams.push({ userIds: [] });
        },
        removeTeam(index) {
            this.selectedTeams.splice(index, 1);
        },
        handleAthleteChange(event) {
            this.selectedAthleteIds = event;
        },
        handleTeamSelectionChange(event) {
            this.selectedTeams = event.map(team => ({
                userIds: team.userIds,
                teamId: team.TeamId,
                teamName: team.TeamName
            }));
        },
        confirmAthleteSelection() {
            if (this.currentProject && this.currentGroupIndex !== null && this.currentProjectIndex !== null) {
                let athletes = [];

                if (this.currentProject.SignUpLimitType === 0) {
                    // 团队模式
                    // 检查是否超过限制
                    if (this.selectedTeams.length > this.currentProject.SignUpLimitNum) {
                        this.$message.warning(`最多只能选择${this.currentProject.SignUpLimitNum}个团队`);
                        return;
                    }
                    athletes = this.selectedTeams.map(team => ({
                        userIds: Array.isArray(team.userIds) ? team.userIds.join(',') : team.userIds,
                        userNames: team.userNames,
                        teamId: team.teamId,
                        teamName: team.teamName
                    }));
                } else {
                    // 个人模式
                    // 检查是否超过限制
                    if (this.selectedAthleteIds.length > this.currentProject.SignUpLimitNum) {
                        this.$message.warning(`该项目最多只能选择${this.currentProject.SignUpLimitNum}名运动员`);
                        return;
                    }
                    athletes = this.selectedAthleteIds.map(id => ({
                        userIds: id,
                        userNames: this.unitAthleteList.find(a => a.AthleteId === id).UserName || ''
                    }));
                }

                // 更新项目的运动员数据
                this.$set(
                    this.signUpMatchGroups[this.currentGroupIndex].Projects[this.currentProjectIndex],
                    'athletes',
                    athletes
                );
            }

            this.athleteDialogVisible = false;
        },
        // 创建新团队
        createTeam() {
            if (!this.tempSelectedAthletes.length) {
                return;
            }

            // 检查团队数量是否已达到限制
            if (this.selectedTeams.length >= this.currentProject.SignUpLimitNum) {
                this.$message.warning(`该项目最多只能添加${this.currentProject.SignUpLimitNum}个团队`);
                return;
            }

            // 获取选中运动员的名字
            const names = this.tempSelectedAthletes.map(id =>
                this.unitAthleteList.find(a => a.AthleteId === id).UserName
            ).filter(Boolean);

            // 创建新团队对象
            const newTeam = {
                userIds: this.tempSelectedAthletes,  // 保持为数组
                userNames: names.join(',')
            };

            // 添加到已选择的团队列表
            this.selectedTeams.push(newTeam);

            // 清空临时选择
            this.tempSelectedAthletes = [];
        },

        // 添加已有团队
        addExistingTeam(team) {
            // 检查团队数量是否已达到限制
            if (this.selectedTeams.length >= this.currentProject.SignUpLimitNum) {
                this.$message.warning(`该项目最多只能添加${this.currentProject.SignUpLimitNum}个团队`);
                return;
            }

            const newTeam = {
                userIds: team.AthleteIds,
                userNames: team.AthleteNames,
                teamId: team.TeamId,
                teamName: team.TeamName
            };

            // 检查是否已经添加过这个团队
            const exists = this.selectedTeams.some(t => t.teamId === team.TeamId);
            if (!exists) {
                this.selectedTeams.push(newTeam);
            } else {
                this.$message.warning('该团队已添加');
            }
        },
        removeAthlete(groupIndex, projectIndex, athleteIndex) {
            const project = this.signUpMatchGroups[groupIndex].Projects[projectIndex];
            if (project.athletes) {
                project.athletes.splice(athleteIndex, 1);
            }
        },
        // 获取扁平化的项目列表（将团队和个人项目展开为单行）
        getFlattenedProjectsList() {
            const flattenedList = [];

            this.signUpMatchGroups.forEach(group => {
                group.Projects.forEach(project => {
                    if (project.athletes && project.athletes.length > 0) {
                        if (project.SignUpLimitType === 0) { // 团队项目
                            project.athletes.forEach(team => {
                                flattenedList.push({
                                    groupName: group.GroupName,
                                    projectName: project.ProjectName,
                                    projectTypeName: project.ProjectTypeName,
                                    genderRuleText: project.GenderRuleText,
                                    athleteName: team.userNames,
                                    // 添加用于合并判断的键
                                    mergeKey: `${group.GroupId}-${project.ProjectId}-${project.ProjectTypeId}-${project.GenderRule}`
                                });
                            });
                        } else { // 个人项目
                            project.athletes.forEach(athlete => {
                                flattenedList.push({
                                    groupName: group.GroupName,
                                    projectName: project.ProjectName,
                                    projectTypeName: project.ProjectTypeName,
                                    genderRuleText: project.GenderRuleText,
                                    athleteName: athlete.userNames,
                                    // 添加用于合并判断的键
                                    mergeKey: `${group.GroupId}-${project.ProjectId}-${project.ProjectTypeId}-${project.GenderRule}`
                                });
                            });
                        }
                    }
                });
            });

            // 按mergeKey排序，确保相同的项目在一起
            flattenedList.sort((a, b) => a.mergeKey.localeCompare(b.mergeKey));
            return flattenedList;
        },
        handleProjectSpanMethod({ row, column, rowIndex, columnIndex }) {
            if (columnIndex > 3) { // 运动员列不合并
                return [1, 1];
            }

            const data = this.getFlattenedProjectsList();

            if (rowIndex === 0) {
                // 第一行的处理
                let rowspan = 1;
                // 向下查找相同值的行数
                for (let i = 1; i < data.length; i++) {
                    if (this.shouldMerge(data[0], data[i], columnIndex)) {
                        rowspan++;
                    } else {
                        break;
                    }
                }
                return [rowspan, 1];
            } else {
                // 其他行的处理
                const prevRow = data[rowIndex - 1];
                const currentRow = data[rowIndex];

                // 如果与上一行相同，则隐藏当前行
                if (this.shouldMerge(prevRow, currentRow, columnIndex)) {
                    return [0, 0];
                }

                // 如果与上一行不同，计算向下合并的行数
                let rowspan = 1;
                for (let i = rowIndex + 1; i < data.length; i++) {
                    if (this.shouldMerge(currentRow, data[i], columnIndex)) {
                        rowspan++;
                    } else {
                        break;
                    }
                }
                return [rowspan, 1];
            }
        },

        shouldMerge(prevRow, currentRow, columnIndex) {
            // 根据列索引判断是否应该合并
            switch (columnIndex) {
                case 0: // 组别
                    return prevRow.groupName === currentRow.groupName;
                case 1: // 项目名称
                    return prevRow.groupName === currentRow.groupName &&
                        prevRow.projectName === currentRow.projectName;
                case 2: // 项目类型
                    return prevRow.groupName === currentRow.groupName &&
                        prevRow.projectName === currentRow.projectName &&
                        prevRow.projectTypeName === currentRow.projectTypeName;
                case 3: // 性别
                    return prevRow.groupName === currentRow.groupName &&
                        prevRow.projectName === currentRow.projectName &&
                        prevRow.projectTypeName === currentRow.projectTypeName &&
                        prevRow.genderRuleText === currentRow.genderRuleText;
                default:
                    return false;
            }
        },
        // 获取所有参赛运动员信息（整合所有项目中的运动员）
        getAllAthletes() {
            // 用于存储唯一的运动员ID
            const uniqueAthleteIds = new Set();

            // 遍历所有选中的项目，收集唯一的运动员ID
            this.signUpMatchGroups.forEach(group => {
                group.Projects.forEach(project => {
                    if (project.athletes && project.athletes.length > 0) {
                        project.athletes.forEach(athlete => {
                            const athleteIds = Array.isArray(athlete.userIds) ?
                                athlete.userIds :
                                athlete.userIds.split(',');

                            athleteIds.forEach(id => {
                                uniqueAthleteIds.add(id);
                            });
                        });
                    }
                });
            });

            const athletes = [];

            // 直接从unitAthleteList中获取运动员信息
            for (const athleteId of uniqueAthleteIds) {
                const athleteOption = this.unitAthleteList.find(a => a.AthleteId === athleteId);
                if (athleteOption) {
                    // 创建运动员对象，使用固定值或者从其他数据源获取更多信息
                    athletes.push({
                        athleteId: athleteId,
                        athleteName: athleteOption.UserName,
                        identityCard: athleteOption.IdentityCard,
                        age: athleteOption.Age,
                        gender: athleteOption.Gender,
                        phone: athleteOption.UserPhone,
                        grade: athleteOption.Grade
                    });
                }
            }

            return athletes;
        },
        tabClick(tab, event) {
            console.log(tab, event, this.tabsValue);
            if (this.tabsValue == '赛事成绩') {
                //查询赛事成绩
                this.getMatchScore();
            }
        },
        getMatchScore() {
            let id = this.$route.params.id;
            this.matchScores = [];
            matchService.getMatchWholeSchedule({ matchId: id }).then(resData => {
                console.log(resData);
                if (resData.code == 0) {

                    let list = [];
                    resData.data.forEach((venue, index) => {
                        let v = {
                            VenueName: venue.VenueName,
                            VenueId: venue.VenueId,
                            Projects: []
                        }
                        let idx = 0;
                        venue.MatchVenueProject.forEach((pro) => {
                            if (pro.Project.IsDisclosure == 1) {
                                let project = {
                                    GroupName: pro.Project.GroupName,
                                    GenderRuleText: pro.Project.GenderRuleText,
                                    ProjectName: pro.Project.ProjectName,
                                    ProjectId: pro.Project.ProjectId,
                                    Regions: [],
                                    ContestantUser: []
                                }

                                if (pro.Project.IsSetRanking) {
                                    let users = [];
                                    pro.Project.Regions.forEach(region => {
                                        region.ContestantUserGroups.forEach(group => {
                                            users = [...users, ...group
                                                .ContestantUsers
                                            ]
                                        });
                                    });
                                    let newUsers = users.filter(a => a.Ranking > 0).sort((a, b) =>
                                        a.Ranking - b.Ranking);
                                    newUsers = [...newUsers, ...users.filter(a => a.Ranking == 0)
                                        .sort((a, b) => a.TotalPoints - b.TotalPoints)
                                    ]
                                    project.ContestantUser = newUsers;
                                }
                                if (project.ContestantUser.length > 0) {
                                    v.Projects.push(project);
                                }

                            }
                        });

                        list.push(v)
                    })

                    this.matchScores = list;
                    console.log(this.matchScores)
                }
            })
        },
        toSignUpRecordPage() {
            console.log(123)
            this.$router.push({ path: '/contestant/competition-record/' + this.matchInfo.MatchName });
        },
        downloadFile(file) {
            if (file.FileSuffix == '.pdf') {
                window.open(this.fileRootPath + file.FilePath, '_blank');

            } else {
                location.href = this.fileRootPath + file.FilePath;

                return false;
            }
        }
    },
    created() {
        this.getMatchDetail();
        this.getUnitTeamLeaders();
        this.getUnitAthletes();
        this.getUnitTeams();
        this.checkUnitIsSignUp();
        this.fileRootPath = Url.getDownloadBaseUrl() + 'uploadfiles/';
        console.log(this.unitInfo)
    },
}
</script>

<style scoped>
.match-sign-up {
    align-items: center;
    box-sizing: border-box;
    overflow: hidden;
    overflow-y: auto;
    height: calc(100vh - 120px);
}

.info-card {
    width: 1200px;
    margin-bottom: 20px;
    margin: 0 auto;
}

.card-header {
    display: flex;
    align-items: center;
}

.match-info {
    padding: 20px;
}

.project-card {
    margin-top: 10px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
}

.attachments {
    display: flex;
    margin-bottom: 5px;
}

.attachments .label,
.attachments .value {
    height: 20px;
    line-height: 20px;
    font-size: 14px;
    font-weight: 600;
}

.attachments .label i {
    margin: 0 5px;
}

.projects {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    padding: 10px;
}

:deep(.el-tabs__content) {
    min-height: 300px;
}

:deep(.action-buttons) {
    margin-top: 30px;
    text-align: center;
}

/* 修改 el-card 的一些默认样式 */
:deep(.el-card__header) {
    padding: 15px 20px;
    border-bottom: 1px solid #ebeef5;
    background-color: #f5f7fa;
}

:deep(.el-card__body) {
    padding: 0px;
}

.member-selection {
    margin: 20px 0;
}

.member-selection h4 {
    margin: 15px 0;
}

/* 修改弹窗内的滚动样式 */
:deep(.el-dialog__body) {
    max-height: 80vh;
    overflow-y: auto;
}

.info-item {
    display: flex;
    margin-bottom: 10px;
    align-items: flex-start;
    color: #606266;
}

.info-item i {
    font-size: 16px;
    color: #909399;
    margin-right: 8px;
    width: 20px;
    text-align: center;
}

.info-label {
    font-weight: 500;
    margin-right: 5px;
    width: 70px;
}

.info-value {
    flex: 1;
    color: #333;
}

:deep(.el-radio input[aria-hidden="true"]) {
    display: none !important;
}

:deep(.el-radio:focus:not(.is-focus):not(:active):not(.is-disabled) .el-radio__inner) {
    box-shadow: none !important;
}

:deep(.el-radio.is-bordered+.el-radio.is-bordered){
    margin-left: 0px;
    margin-bottom: 10px;
}

/* 更新上传相关样式 */
.upload-container {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.avatar-uploader,
.id-card-uploader {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 300px;
    height: 300px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 10px;
    margin: 0 auto;
}

.avatar-uploader:hover,
.id-card-uploader:hover {
    border-color: #409EFF;
}

.upload-placeholder {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: #8c939d;
    width: 100%;
    height: 100%;
}

.upload-placeholder i {
    font-size: 28px;
    margin-bottom: 8px;
}

.image-delete {
    position: absolute;
    text-align: center;
    width: 30px;
    height: 30px;
    line-height: 30px;
    top: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.2);
    border-radius: 15px;
    color: red;
    cursor: pointer;
    display: none;
    font-size: 16px;
    z-index: 999;
}

.avatar-uploader:hover .image-delete,
.id-card-uploader:hover .image-delete {
    display: block;
}

:deep(.teamPhoto .el-upload--text) {
    padding: 45px 65px !important;
    box-sizing: border-box !important;
}

/* 调整表格样式 */
:deep(.el-table) {
    /* 加深表格边框颜色 */
    --el-table-border-color: #DCDFE6;
    border-color: #DCDFE6;
}

:deep(.el-table td.el-table__cell),
:deep(.el-table th.el-table__cell) {
    /* 加深单元格边框颜色 */
    border-color: #DCDFE6;
}

:deep(.el-table__cell) {
    /* 加深文字颜色 */
    color: #303133;
}

:deep(.el-table__header-wrapper) {

    /* 加深表头背景色和文字颜色 */
    th.el-table__cell {
        background-color: #F5F7FA;
        color: #303133;
        font-weight: 600;
    }
}

/* 可选：鼠标悬停时的行背景色 */
:deep(.el-table__body tr:hover > td.el-table__cell) {
    background-color: #F5F7FA;
}


:deep(.create-team .el-select) {
    width: 80% !important;
}

.team-select {
    padding: 10px;
}

.selected-teams {
    margin-bottom: 20px;
}

.team-list {
    margin: 10px 0;
}

.create-team {
    margin-bottom: 20px;
}

.select-team {
    margin-top: 20px;
}

h4 {
    margin: 10px 0;
    color: #606266;
}

.el-divider {
    margin: 20px 0;
}

.compact-table {
    /* 添加自定义类名 */
}

.sign-up-confirmation {
    text-align: left;
    padding: 20px;
}

.info-table {
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 20px;
    table-layout: fixed;
    /* 添加固定表格布局 */
}

.info-table td {
    padding: 8px;
    border: 1px solid #DCDFE6;
    line-height: 24px;
}

.info-table .label {
    background-color: #F5F7FA;
    font-weight: bold;
    width: 120px;
}

/* 确保第三列标签的宽度与第一列一致 */
.info-table td:nth-child(3).label {
    width: 120px;
}

.projects-list,
.staff-list {
    margin-top: 20px;
}

.projects-list h4,
.staff-list h4 {
    margin-bottom: 10px;
    color: #303133;
    font-weight: bold;
}

:deep(.el-table) {
    margin-bottom: 20px;
}

/* 添加表格相关样式 */
:deep(.el-table td.el-table__cell) {
    padding: 8px 0;
}

:deep(.el-table .cell) {
    padding: 0 8px;
}
</style>
